var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"text-small",attrs:{"id":"main_footer"}},[_c('nav',{staticClass:"flex-vcenter"},[_c('div',{staticClass:"content"},[_vm._t("left-links")],2),_c('div',{staticClass:"content"},[_vm._t("right-links"),_c('span',{attrs:{"id":"copyright"}},[_vm._v("© "+_vm._s(_vm.currentYear)+" LDE")])],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }